{
  "EMAIL_TEMPLATE_NOT_FOUND": "Email template not found",
  "EMAIL_TEMPLATE_DEFAULT_NOT_FOUND": "There is no default content for \"{{slug}}\"",
  "EMAIL_TEMPLATE_SLUG_TAKEN": "A template with the slug \"{{slug}}\" already exists in this language",
  "EMAIL_TEMPLATE_LANGUAGE_INVALID": "Invalid template language"
}
